<template>
    <div class="ml-0" style="max-width: 800px;">
		<div class="row">
			<div class="col-12">
				<div class="form-group">
					<label class="form-label" for="company-name">Company Name</label>
					<input type="text" class="form-control" id="company-name" placeholder="Company Name" v-model="companyData.name">
				</div>
			</div>

			<div class="col-12 col-md-4">
				<div class="form-group">
					<label class="form-label" for="company-staff-limit">Staff Limit</label>
					<input style="max-width: 100px" type="number" min="0" class="form-control" id="company-staff-limit" placeholder="Staff Limit" v-model="companyData.staff_limit">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<search-or-create-model
					v-model="companyData.user"

					:label-above="true"
					label="Manager"
					label-class="form-label"
					:search_url="user_url"

					:model_template="[
						{label: 'Last Name', prop: 'last_name'},
						{label: 'Email', prop: 'email'}
					]"

					:errors="[]"
					model_name="user"

					:selected="user_selected"
					@select_model="user_selected = true"
					@unselect_model="user_selected = false"
				></search-or-create-model>
			</div>
		</div>

		<div class="row">
			<div class="col-12" v-if="saving">
				<loader></loader>
			</div>
		</div>

		<!--Forms-->
		<div v-if="forms" class="row mt-4">
			<div class="col-12">
			</div>
			<div class="col-12">
				<h5 class="form-label">Forms</h5>
			</div>
			<div class="col-12">
				<div class="main--content-header content-header">
					<div class="content-header--navbar">
						<ul class="content-header--navbar-list">
							<li class="content-header--navbar-list-item" v-bind:class="selected_type === 'standard' ? 'active' : ''">
								<a class="content-header--navbar-list-item-link" v-on:click="selected_type = 'standard'" href="javascript:void(0)">Standard</a>
							</li>
							<li class="content-header--navbar-list-item" v-bind:class="selected_type === 'custom' ? 'active' : ''">
								<a class="content-header--navbar-list-item-link" v-on:click="selected_type = 'custom'" href="javascript:void(0)">Custom</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<!--Standard forms-->
			<div v-if="selected_type === 'standard'" class="col-12">
				<list-component
					:items="forms"
					:can_click="false"
					no_results_message="No forms used from library"

					toggle_property="unarchived"
					toggle_method="post"
					:update_toggle_url="toggle_url"
				></list-component>
			</div>

			<!--Custom Forms-->
			<div v-else-if="selected_type === 'custom'" class="col-12">
				<list-component
					:items="cloned_forms_edit"
					:can_click="false"
					no_results_message="No forms used from library"

					toggle_property="unarchived"
					toggle_method="post"
					:update_toggle_url="toggle_url"
				></list-component>

				<button class="btn btn-primary mt-4" v-on:click="openCloneModal()">Clone from library</button>
			</div>

			<clone-from-library-modal
				ref="clone"

				:forms="library_forms"
				:clone_url="clone_url"

				@cloned="addCustomForm"
			></clone-from-library-modal>
		</div>
    </div>
</template>

<script>
    import SearchOrCreateModel from "../../general_components/SearchOrCreateModel";
	import Loader from "../../general_components/Loader";
	import CloneFromLibraryModal from "../../modals/CloneFromLibraryModal";

    export default {
        name: "CompanyCreateEditPage",
        components: {CloneFromLibraryModal, Loader, SearchOrCreateModel},

        props: {
            submit_url: {
                type: String,
                required: true
            },
			clone_url: {
            	type: String,
				required: true
			},
            company: {
                type: Object,
                default: () => { return {}; }
            },

			forms: {
            	type: Array,
				default: () => { return []; }
			},

			cloned_forms: {
            	type: Array,
				default: () => { return []; }
			},

			library_forms: {
            	type: Array,
				default: () => { return []; }
			},

            user_url: {
                type: String,
                required: true
            },

            style_options: {
                type: Object,
                required: true
            },

			back_url: {
            	type: String,
				required: true
			},

            toggle_url: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                companyData: {
                    name: '',
                    staff_limit: 50,
					style: 'default',

                    user: {
                        first_name: '',
                        last_name: '',
                        email: ''
                    },

                    errors: []
                },

				selected_type: 'standard',
				types: ['custom', 'standard'],

				cloned_forms_edit: [],

                saving: false,
                user_selected: false
            }
        },

        beforeMount() {
        	if (this.company){
				if(this.company.user && this.company.user.id){
					this.user_selected = this.company.user.id;
				}

				this.cloned_forms_edit = this.cloned_forms ? Object.assign([], this.cloned_forms) : [];

				this.companyData = Object.assign({}, this.company);
			}

			window.addEventListener('LAYOUT:primary_button', this.save);
			window.addEventListener('LAYOUT:cancel_button', this.cancel);
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    'method': this.company ? 'put' : 'post',
                    'url': this.submit_url,
                    'data': this.companyData
                }).then((response) => {
                    console.log(response.data);
                    this.saving = false;
					window.location.href = this.back_url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },
			cancel(){
            	window.location.href = this.back_url;
			},

			openCloneModal(){
            	this.$refs.clone.openModal();
			},

			addCustomForm(form){
            	this.cloned_forms_edit.push(form);
			},
        }
    }
</script>
